import React, { useEffect, useState, useRef } from 'react';
import "./SpecialistFormDays.scss"
import Input from '../../../UI/Input/Input';
import { toggleArrayItem } from '../../../../helpers/general';
import { days } from '../../../../helpers/datetime';

const SpecialistFormDays = ({ recieveWorkingDays = null, restInterval = '', workInterval = '', workingDaysList = [], errorMessage = '' }) => {
    const [daysList, setDaysList] = useState([]);
    const [selectedDays, setSelectedDays] = useState([]);
    const [rest, setRest] = useState('');
    const [work, setWork] = useState('');
    const [resetKey, setResetKey] = useState(false);

    useEffect(() => {
        let daysSelected = [];
        let weekdays = getSelectedDaysAsNumbers(workingDaysList);
        if (weekdays) {
            daysSelected = weekdays.map((el) => Number(el));
        }
        setSelectedDays(daysSelected)
        let daysAr = createDaysArray(daysSelected)
        setDaysList(daysAr)
        setRest(restInterval);
        setWork(workInterval);
    }, [])

    const selectDay = (id) => {
        let newSelectedDays = toggleArrayItem(selectedDays, id)
        setSelectedDays(newSelectedDays)
        let daysAr = createDaysArray(newSelectedDays)

        setDaysList(daysAr)
        if (newSelectedDays.length > 0) {
            setResetKey(true);
            setWork('');
            setRest('');
        }

        recieveWorkingDays({ work: '', rest: '', days: selectedDays })
    }

    function getSelectedDaysAsNumbers(workingDaysList) {
        const selectedDays = workingDaysList.map(day => parseInt(day, 10));
        return selectedDays;
    }

    const createDaysArray = (selected = []) => {
        const arDays = [];
        for (let i = 0; i < days.length; i++) {
            let newElem = {};
            newElem['value'] = days[i][1];
            newElem['selected'] = selected.indexOf(i === 0 ? 7 : i) !== -1;
            arDays.push(newElem);
        }
        return arDays;
    }

    const handleInputRestChange = (value) => {
        setRest(value);

        const resetDaysList = daysList.map(day => ({
            ...day,
            selected: false
        }));
        setDaysList(resetDaysList);
        setSelectedDays([]);

        setResetKey(false);
        recieveWorkingDays({ work: work, rest: value, days: [] })
    }

    const handleInputWorkChange = (value) => {
        setWork(value);

        const resetDaysList = daysList.map(day => ({
            ...day,
            selected: false
        }));
        setDaysList(resetDaysList);
        setSelectedDays([]);

        setResetKey(false);
        recieveWorkingDays({ work: value, rest: rest, days: [] })
    }



    useEffect(() => {
        if (!!work && !!rest) {
            const resetSelected = daysList.map(elem => {
                return { ...elem, selected: false };
            });
            setDaysList(resetSelected);
            setSelectedDays([]);
        }
    }, [rest, work])

    return (
        <div className="specialist-form-days">
            <div className="specialist-form-days__rotational">
                <div className="specialist-form-days__rotational-working">
                    <Input
                        type="days"
                        label="Рабочих дней"
                        defaultValue={work}
                        resetKey={resetKey}
                        inputHandler={handleInputWorkChange}
                    />
                </div>
                <div className="specialist-form-days__rotational-separator">
                    через
                </div>
                <div className="specialist-form-days__rotational-weekends">
                    <Input
                        type="days"
                        label="Выходных дней"
                        defaultValue={rest}
                        resetKey={resetKey}
                        inputHandler={handleInputRestChange}
                    />
                </div>
            </div>
            <div className="specialist-form-days__separator">или</div>
            <div className="specialist-form-days__weekdays">
                <span className="specialist-form-days__weekdays-title">Желаемые дни недели</span>
                <div className="specialist-form-days__weekdays-list">
                    {daysList.map((el, index) => {
                        const itemId = index === 0 ? 7 : index;
                        return (
                            <div
                                className={'specialist-form-days__weekdays-btn' + (el.selected ? ' active' : '')}
                                key={el.value}
                                onClick={() => selectDay(itemId)}>
                                {el.value}
                            </div>
                        )
                    })}
                </div>
            </div>
            {errorMessage !== '' &&
                <div className="specialist-form-days__error">
                    {errorMessage}
                </div>
            }
        </div>
    );
}

export default SpecialistFormDays;